var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdaptabilidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.505066,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6159 19.5884C31.0826 19.5884 31.4492 19.9551 31.4492 20.4217L31.4492 23.7551L41.4492 23.7551L41.4492 33.7551L44.7826 33.7551C45.2492 33.7551 45.6159 34.1217 45.6159 34.5884C45.6159 35.0551 45.2492 35.4217 44.7826 35.4217L41.4492 35.4217L41.4492 45.4217L37.9159 45.4217C36.7826 42.5051 33.9326 40.4217 30.6159 40.4217C27.2992 40.4217 24.4492 42.5051 23.3159 45.4217L19.7826 45.4217L19.7826 41.8884C22.6992 40.7551 24.7826 37.9051 24.7826 34.5884C24.7826 31.2717 22.7159 28.4217 19.7992 27.2884L19.7826 23.7551L29.7826 23.7551L29.7826 20.4217C29.7826 19.9551 30.1492 19.5884 30.6159 19.5884ZM30.6159 16.2551C28.3159 16.2551 26.4492 18.1217 26.4492 20.4217L19.7826 20.4217C17.9492 20.4217 16.4659 21.9217 16.4659 23.7551L16.4659 30.0884L16.9492 30.0884C19.4326 30.0884 21.4492 32.1051 21.4492 34.5884C21.4492 37.0717 19.4326 39.0884 16.9492 39.0884L16.4492 39.0884L16.4492 45.4217C16.4492 47.2551 17.9492 48.7551 19.7826 48.7551L26.1159 48.7551L26.1159 48.2551C26.1159 45.7717 28.1326 43.7551 30.6159 43.7551C33.0992 43.7551 35.1159 45.7717 35.1159 48.2551L35.1159 48.7551L41.4492 48.7551C43.2826 48.7551 44.7826 47.2551 44.7826 45.4217L44.7826 38.7551C47.0826 38.7551 48.9492 36.8884 48.9492 34.5884C48.9492 32.2884 47.0826 30.4217 44.7826 30.4217L44.7826 23.7551C44.7826 21.9217 43.2826 20.4217 41.4492 20.4217L34.7826 20.4217C34.7826 18.1217 32.9159 16.2551 30.6159 16.2551Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdaptabilidad);
export default __webpack_public_path__ + "static/media/icon-adaptabilidad.6332fd20d657df447bdc63df692970c6.svg";
export { ForwardRef as ReactComponent };